


import Sortable from 'html5sortable'

export default {
  componentUpdated: (el, bind) ->
    # console.log 
    #   el: el
    #   bind: bind
    # Callback to execute on update
    onUpdate = bind.value

    options = 
        items: Object.keys(bind.modifiers)[0]
        handle: '.my-handle'
        forcePlaceholderSize: true
    
    sortUpdate = (e) ->
      console.log 'e.detail: ', e.detail
      try
        onUpdate(e.detail.newStartList, e.detail.item.dataset)
      catch err
        console.log err, e

    sortable = Sortable el, options
    sortable[0].addEventListener 'sortupdate', sortUpdate
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sortable.vue